import React from "react";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";

const PoweredBy = ({ withBottom }) => {
  return (
    <Box mt={2} className={`powered-by ${withBottom && "with-bottom"}`}>
      <Grid container>
        <Grid item xs={12}>
          <Typography variant="body2" color="textSecondary">
            Powered By
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <a
            href="https://www.carritofacil.cl/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/loading-logo.png`}
              alt="Carrito Fácil"
            />
          </a>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PoweredBy;
